export default {
    SET_MOVIMIENTOS_CAJAS: (state, payload) => {
        state.movimientosCajas = payload;
    },
    SET_MOVIMIENTOS_CAJAS_FILTROS: (state, payload) => {
        state.movimientosCajasFiltros = payload;
    },
    SET_MOVIMIENTOS_CAJAS_EXPORT: (state, payload) => {
        state.movimientosCajasExport = payload;
    },
    SET_MOVIMIENTOS_CAJAS_FILTERS_EXPORT: (state, payload) => {
        state.movimientosCajasFiltersExport = payload;
    },
    SET_MOVIMIENTOS_OTROS: (state, payload) => {
        state.movimientosOtros = payload
    },
    SET_CAJAS: (state, payload) => {
        state.cajas = payload
    },
    SET_CAJAS_FILTROS: (state, payload) => {
        state.cajasFiltros = payload
    },
    SET_CAJAS_EXPORT: (state, payload) => {
        state.cajasExport = payload
    },
    SET_CAJAS_FILTERS_EXPORT: (state, payload) => {
        state.cajasFiltersExport = payload
    },
    SET_ALL_STATE_MOVIMIENTOS_BANCOS: (state, payload) => {
    
    },
    SET_ALL_STATE_MOVIMIENTOS_OTROS: (state, payload) => {
    
    },
    SET_STATUS_API_CODIGO_C: (state, payload) => {
        state.statusApiCodigoC = payload
    },
    SET_STATUS_API_CAJA: (state, payload) => {
        state.statusApiCaja = payload
    },
    SET_TOTAL_MOVIMIENTOS_CAJA: (state, payload) => {
        state.totalMovimientosCaja = payload
    },
    SET_TOTAL_CAJAS: (state, payload) => {
        state.totalCajas = payload
    }
}